import { Card } from 'antd';
import { type EOverdueType, useOverdueFiltersStore } from 'shared/stores/use-overdue-filters';
import { OverdueSection } from 'components/statistics/overdue-section';
import { overdueTabs } from './constants';

export const OverdueTabs = () => {
  const { filters, setFilters } = useOverdueFiltersStore();

  const onTabChange = (key: string) => {
    setFilters({ ...filters, type: key as EOverdueType });
  };

  return (
    <Card style={{ width: '100%' }} tabList={overdueTabs} activeTabKey={filters.type} onTabChange={onTabChange}>
      <OverdueSection />
    </Card>
  );
};
